import type {BuildId} from '../types'

export const compatibleAgentsFields = `compatibleAgents($locator(count:16),count),compatibleCloudImages($locator(count:16),count)`

export const getCompatibleAgentsArg = (buildId: BuildId) => ({
  buildLocator: `id:${buildId}`,
  fields: `id,${compatibleAgentsFields}`,
})
